export default __webpack_public_path__ + "b55936a398bf6ca5d6ef422b325287f7.jpg";